import React from "react";
import FooterAreaOne from "../components/FooterAreaOne";
import SubscribeOne from "../components/SubscribeOne";
import Preloader from "../helper/Preloader";
import useInitialLoad from "../helper/useInitialLoad";
import { Helmet } from "react-helmet-async";
import NotFound from "../components/NotFound";


const HomePageOne = () => {
  const showPreloader = useInitialLoad(2000);

  return (
    <>
      {/* Preloader */}
      {showPreloader && <Preloader />}

      <Helmet>
        {/* <!-- Basic SEO tags --> */}
        <title>No se encuentra la página • Leal | Chapa y Pintura - Mecánica</title>
        <meta name="language" content="Spanish" />
        <meta name="author" content="www.lealchapaypintura.com" />
        <meta
          name="description"
          content="Con más de 15 años de trayectoria, en Leal Chapa y Pintura
          combinamos dedicación, técnica y un profundo compromiso con la
          calidad. C. Congreso, 57 | Pol. P.I.S.A"
        />
        <meta
          name="keywords"
          content="Reparación, Pintura, ITV, chapa y pintura, Automoviles, Motos, Mecánica, Rápida, Chapa, Pintura, Mairena Del Aljarafe, pisa, Sevilla"
        />
        <meta name="robots" content="index, follow" />
        <meta charset="UTF-8" />

        {/* <!-- Open Graph tags for better social media sharing --> */}
        <meta
          property="og:title"
          content="Leal | Chapa y Pintura - Mecánica • Reparación & Servicio Profesional para Automóviles"
        />
        <meta
          property="og:description"
          content="Con más de 15 años de trayectoria, en Leal Chapa y Pintura
          combinamos dedicación, técnica y un profundo compromiso con la
          calidad. C. Congreso, 57 | Pol. P.I.S.A"
        />
        <meta property="og:image" content="%PUBLIC_URL%/favicon.ico" />
        <meta property="og:url" content="%PUBLIC_URL%" />
        <meta property="og:type" content="website" />

        {/* <!-- Twitter Card tags for better social media sharing --> */}
        <meta
          name="twitter:title"
          content="Leal | Chapa y Pintura - Mecánica • Reparación & Servicio Profesional para Automóviles"
        />
        <meta
          name="twitter:description"
          content="Con más de 15 años de trayectoria, en Leal Chapa y Pintura
          combinamos dedicación, técnica y un profundo compromiso con la
          calidad. C. Congreso, 57 | Pol. P.I.S.A"
        />

      </Helmet>
      {/* Hero One */}
      {/* <HeroOne /> */}
      <NotFound />
      {/* Subscribe One */}
      <SubscribeOne />

      {/* Footer Area One */}
      <FooterAreaOne />
    </>
  );
};

export default HomePageOne;
